'use strict';

function LoanOffersMogoNoOfferMobile() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [];

  this.analytics = new Analytics();

  this.init = function () {
    this.analytics.forcePushEvent('virtual-page-view');
  };

  this.initAllReady = function () {};

  this.destroy = function () {};
}